import { ListBase } from './../tools/ListBase';


class Usuarios extends ListBase {

  constructor ({props, context}) {
    super();
    this.state = {rows: [], cls: 'usuarios'};
    this.title = 'Usuarios';
    this.state.columns = [
      {
        field: 'Nombre',
        headerName: 'Nombre',
        width: 250,
      },
      {
        field: 'Apellido',
        headerName: 'Apellido',
        width: 250,
      },
      {
        field: 'NombreUsuario',
        headerName: 'Nombre Usuario',
        width: 210,
      },
      {
        field: 'idPermisoUsuario',
        headerName: 'Permisos',
        sortable: true,
        width: 260,
        valueGetter: (params) => {
            return params.row.PermisosUsuario.Nombre
        }
      },
    ];
  }

}


import { useNavigate } from 'react-router-dom';

function UsuariosWithNavigate(props) {
  const navigate = useNavigate();
  return <Usuarios {...props} navigate={navigate} />;
}

export default UsuariosWithNavigate;